<!-- <p>password-change-popup-dialog works!</p> -->
<div>
  <h1 mat-dialog-title>Password Change Reminder</h1>
  <mat-dialog-content class="mat-typography">
    <div class="add-user-dialog-status">
      <i>Please Update your password from user profile</i>
    </div>

    <mat-divider></mat-divider>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
